import React from "react";
import Calender from "./Calender";

const CalenderCom = () => {
  return (
    <div className="p-4 h-2/4 bg-white w-full  rounded-md border ">
      <Calender></Calender>
    </div>
  );
};

export default CalenderCom;
